import { useIsFocused } from '@react-navigation/native'
import { clsx } from 'clsx'
import { type FC, type ReactNode } from 'react'

import { HStack, Text, VStack, type HStackProps } from '@/components'
import { useFocusableRef } from '@/hooks'

export interface HeaderTitleProps
  extends Omit<HStackProps, 'accessibilityElementsHidden' | 'aria-hidden' | 'importantForAccessibility'> {
  left?: ReactNode
  right?: ReactNode
  subtitle?: string | null | undefined
  title: string | null | undefined
}

export const HeaderTitle: FC<HeaderTitleProps> = ({
  accessibilityLabel,
  left,
  right,
  subtitle,
  style,
  title,
  ...props
}) => {
  const isFocused = useIsFocused()
  const [titleRef] = useFocusableRef(true)

  return isFocused ? (
    <HStack
      className='h-full w-full items-center gap-3 py-1'
      {...props}
    >
      {left}
      <VStack
        accessible
        accessibilityLabel={accessibilityLabel ?? `${title} screen${subtitle ? `. ${subtitle}` : ''}`}
        accessibilityRole='header'
        aria-level={1}
        className='justify-between'
        importantForAccessibility='yes'
        ref={titleRef}
        tabIndex={0}
      >
        <Text
          accessibilityElementsHidden
          aria-hidden
          importantForAccessibility='no-hide-descendants'
          className={clsx('font-poppinsBold text-white', subtitle ? 'text-lg' : 'text-xl')}
          numberOfLines={1}
        >
          {title}
        </Text>
        {subtitle ? (
          <Text
            accessibilityElementsHidden
            aria-hidden
            importantForAccessibility='no-hide-descendants'
            className='font-poppinsMedium text-xs text-white'
            numberOfLines={1}
          >
            {subtitle}
          </Text>
        ) : null}
      </VStack>
      {right}
    </HStack>
  ) : null
}
